<template>
  <button class="emat-button" type="button" :class="[bgColor || mobile, {radiusLeft: radius === 'left', radiusRight: radius === 'right'}]" :disabled="disabled"
          @click="$emit('click')">
    <cart v-if="showIcon"></cart>
    <slot></slot>
  </button>
</template>

<script>
import Cart from '../../../assets/icons/cart.svg?inline'

export default {
  name: 'Button',
  props: {
    /**
     * A string containing the color of the button: {use as: [bgColor="blue"] or [bgColor="green"]}
     */
    bgColor: {
      type: String,
      required: true,
      default: 'blue',
    },
    /**
     * A boolean specifying whether the button is disabled or not: {use as: [:disabled="true"]}
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * A boolean specifying whether to use a cart icon: {use as: [:icon="true"]}
     */
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * A boolean specifying whether to use a cart icon: {use as: [:icon="true"]}
     */
    mobile: {
      type: String,
      required: false,
    },
    radius: {
      type: String,
      required: false,
    },
  },
  components: {
    Cart
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";


.emat-button {
  @include header-font;
  max-width: 275px;
  width: 100%;
  height: 48px;
  color: white;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: all ease 0.3s;
  border-radius: $border-radius;
  padding: 0;

  &.radiusLeft {
   border-bottom-right-radius: 0;
   border-top-right-radius: 0;
  }
  &.radiusRight {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  img {
    transition: all ease 0.3s;
  }

  &.blue {
    background-color: var(--c-primary);

    &:hover {
      background-color: var(--c-primary-dark);
    }
  }

  &.green {
    background-color: var(--c-success);

    &:hover {
      background-color: var(--c-green-dark);
    }
  }

  &.red {
    background-color: var(--c-danger);

    &:hover {
      background-color: var(--c-danger-dark);
    }
  }

  &:hover {
    img {
      transform: scale(1.2);
    }
  }

  &:disabled {
    background-color: var(--c-primary) !important;
    opacity: 0.2;
    cursor: not-allowed;
  }

  &:focus, :active {
    outline: none;
  }
}

.open-mobile-menu {
  background: var(--c-primary);
  color: $c-white;
  position: absolute;
  left: 0;
  top: 86px;
  font-family: var(--font);
  padding: 0 10px;
  font-size: 13px;
  transform-origin: top right;
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
  text-align: center;
  transition: all .3s linear;

  //&.open {
  //  left: 100%;
  //  transform: translateX(-100%) rotate(270deg) translateY(-100%);
  //
  //  img {
  //    transform: rotate(180deg);
  //  }
  //}

  span {
    padding-left: 20px;
  }
}

.close-mobile-menu {
  background: var(--c-primary);
  color: #fff;
  position: fixed;
  right: 0;
  top: 50px;
  font-family: var(--font);
  padding: 0 10px 0 30px;
  font-size: 13px;
  transform-origin: top right;
  transform: rotate(270deg) translateY(-100%);
  height: 30px;
  line-height: 30px;
  width: 200px;
  box-sizing: border-box;
  text-align: center;
  transition: all .3s ease;
  z-index: 2;

  span {
    padding-left: 20px;
  }
}
</style>
